import SignUpStep1Form from './Step1'
import SignUpStep2Form from './Step2'
import SignUpStep3Form from './Step3'

// Title literal of each step, for whoever hosts the forms.
export const SIGN_UP_STEP_TITLES = ['yourUserData', 'whoAreYou', 'termsOfUse']

export { SignUpStep1Form, SignUpStep2Form, SignUpStep3Form }
